module.exports = __webpack_public_path__ + "static/media/Loan2.665107df.svg";